/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PuzzlePiecePlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABPElEQVR4nO2VzUoDQQzHq2AvemmPvfg0vVgnyQohsXheUKF4ao97rUjrO1l8FD9A0aPopTLrqnQ303X7AQoO5BKS/y/JZGdrtf9T9TBzHUjOHcotkE5TQ71LkmTTCN8AkvvPOEdyA6RDrxEE+IAvYfo2Zm4axTStWK8RBGRVFJMiPS0UE2nPivUa8zqwKpoCyosjOWbmnXb7aHsfD0+8LxRfHUDVzBTvdLqNtQCYue5QR47keS0AILlclTAEAA+/FuBQXx1qH0Bb3hzKwPvyuz9eHCCD/LIUfHEcbwHpBZA8VYaAtj6K1GtAmaQTyXxLr6lDecx/P6bw7H2Uzxwi7flirLxVAM7m5ZUCgo8dzb6q6czLxpjdyY+ea8gBfHJpt6RXgR+ODq1OHMrb3kF3d6kRLXrg7wNQJtbM3wGgET90souaCgAAAABJRU5ErkJggg==)
 */
export const PuzzlePiecePlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16 4a3 3 0 1 1-5.98-.31c.03-.35-.21-.69-.56-.69H7a3 3 0 0 0-3 3v2.5c0 .28-.23.5-.5.54a3 3 0 0 0 0 5.92c.27.04.5.26.5.54V18a3 3 0 0 0 3 3h4.65c.43 0 .69-.55.54-.95A3 3 0 0 1 15 16h.5a.5.5 0 0 0 .5-.5V15a3 3 0 1 1 6 0V6a3 3 0 0 0-3-3h-2.46c-.35 0-.6.34-.56.69L16 4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
